import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  question_type: Yup.object()
    .required('Input Type is required')
    .nullable(),
  
  question: Yup.string()
    .trim()
    .required('Question is required'),
  
  is_required: Yup.string()
    .oneOf(['yes', 'no'], 'Invalid value')
    .required('Required field toggle is required'),

  status: Yup.string()
    .oneOf(['active', 'archived'], 'Invalid status')
    .required('Status is required'),

  options: Yup.array().when('question_type', {
    is: (val) =>
      val?.value === 'checkbox' ||
      val?.value === 'radio' ||
      val?.value === 'select',
    then: (schema) =>
      schema
        .of(
          Yup.object().shape({
            value: Yup.string().required('Option value is required'),
            // If you plan to use label later, uncomment below:
            // label: Yup.string().required('Label is required'),
          })
        )
        .min(1, 'At least one option is required'),
    otherwise: (schema) => schema.notRequired(),
  }),
});
